function initGoTop() {
	const $btn = $('.go-top');

	// 如果頁面上沒有該元素，則不執行
	if (!$btn.length) return;

	if ($btn.hasClass('fixed')) {
		const $fBtn = $('.go-top.fixed');
		const $footer = $('footer');

		const SHOW_AFTER_PX = 300; // 滾動超過 300px 後顯示
		const HIDE_BEFORE_FOOTER_PX = 30; // 距離 Footer 30px 前隱藏

		function updateVisibility() {
			const scrollTop = $(window).scrollTop();
			const windowHeight = $(window).height();
			// 取得 footer 位置，若無 footer 則設為無限大
			const footerTop = $footer.length ? $footer.offset().top : Infinity;

			// 判斷 1: 是否在頁面頂端附近
			const isAtTop = scrollTop < SHOW_AFTER_PX;

			// 判斷 2: 是否接近 Footer
			// 計算公式: (目前捲軸高度 + 視窗高度) > (Footer 頂部位置 - 緩衝距離)
			const isNearFooter = (scrollTop + windowHeight) > (footerTop - HIDE_BEFORE_FOOTER_PX);

			// 邏輯: 如果 "在頂端" 或者 "太靠近 Footer"，就隱藏
			if (isAtTop || isNearFooter) {
				// 隱藏: 透明 + 不可點擊
				$fBtn.addClass('opacity-0 pointer-events-none')
					.removeClass('opacity-100 pointer-events-auto');
			} else {
				// 顯示: 不透明 + 恢復點擊
				$fBtn.removeClass('opacity-0 pointer-events-none')
					.addClass('opacity-100 pointer-events-auto');
			}
		}

		// 綁定 Scroll 與 Resize 事件
		// 簡單的 throttle 機制可選，這裡直接綁定即可，現代瀏覽器效能通常足夠
		$(window).on('scroll resize', updateVisibility);

		// 初始化時先執行一次，避免重新整理後狀態不對
		updateVisibility();
	}

	// 1. 點擊滾動回頂部邏輯
	$btn.on('click', function (e) {
		e.preventDefault();

		// 使用 GSAP ScrollToPlugin 達到最平滑的效果
		// 根據頁面高度動態調整時間，或固定時間皆可，這裡設定 1.2秒
		gsap.to(window, {
			duration: 1.2,
			scrollTo: { y: 0 },
			ease: "power2.inOut"
		});
	});
}

function initGoBtm() {
	const $btn = $('button.burger');

	// 如果頁面上沒有該元素，則不執行
	if (!$btn.length) return;

	// 1. 點擊滾動回頂部邏輯
	$btn.on('click', function (e) {
		e.preventDefault();

		// 使用 GSAP ScrollToPlugin 達到最平滑的效果
		// 根據頁面高度動態調整時間，或固定時間皆可，這裡設定 1.2秒
		gsap.to(window, {
			duration: 1.2,
			scrollTo: 'footer',
			ease: "power2.inOut"
		});
	});
}

export {
	initGoTop
};